module.exports = __webpack_public_path__ + "img/25.a54bd751.png";